// Paper sizes (dimensions in PDF points; 1pt = 1/72 inch)
export const PAPER_SIZES = {
  LETTER: { width: 792, height: 612, name: 'Letter (8.5" × 11")' },
  LEGAL: { width: 1008, height: 612, name: 'Legal (8.5" × 14")' },
  TABLOID: { width: 1224, height: 792, name: 'Tabloid (11" × 17")' },
  A4: { width: 842, height: 595, name: 'A4 (210mm × 297mm)' },
  A3: { width: 1191, height: 842, name: 'A3 (297mm × 420mm)' },
  A5: { width: 595, height: 420, name: 'A5 (148mm × 210mm)' },
  A10: { width: 148, height: 105, name: 'A10 (26mm × 37mm)' },
  CUSTOM: { width: -11, height: 0, name: 'Custom Size' },
};

// Thumbnail generation
export const THUMBNAIL_WIDTH_PX = 120;

// Preview layout
export const MAX_PAGES_PER_ROW = 8;

// Guide rendering (fold line and hole guides)
export const GUIDE_OPACITY = 0.3;
export const GUIDE_THICKNESS = 0.5;

// Debug page number overlay
export const DEBUG_PAGE_NUMBER_SIZE = 60;
export const DEBUG_PAGE_NUMBER_OPACITY = 0.5;

// Output page number overlay
export const OUTPUT_PAGE_NUMBER_MARGIN = 20;
// Width of the landscape .page-card in the preview (px) — used to scale font size to PDF points
export const PREVIEW_LANDSCAPE_CARD_WIDTH_PX = 92;

// Donation options
export const DONATION_AMOUNTS = [
  { amount: 3, link: 'https://buy.stripe.com/9AQ4hs5mjef99Ta002' },
  { amount: 5, link: 'https://buy.stripe.com/5kA7tE5mj9YT1mE5kl' },
  { amount: 10, link: 'https://buy.stripe.com/9AQ9BM8yv0ojaXefYY' },
];
